import { useEffect, useState } from "react";
import { api, dollars } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

// Chart style constants — hoisted out of the render body so their references
// stay stable across renders (recharts sees the same object each time and
// skips its internal diff work).
const CHART_MARGIN = { top: 8, right: 8, left: -20, bottom: 40 };
const AXIS_TICK = { fill: "#9CA3AF", fontSize: 10, fontFamily: "JetBrains Mono" };
const TOOLTIP_STYLE = { background: "#0A0A0A", border: "1px solid #2A2A2A", borderRadius: 0, fontFamily: "JetBrains Mono", fontSize: 12 };

export default function ArtistAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/artist/analytics").then((r) => setData(r.data)).catch(() => setData({})); }, []);
  if (!data) return <div className="p-8 font-mono text-xs text-gray-500 uppercase">Loading analytics...</div>;

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4 mb-6">
        <Stat label="Followers" value={data.followers || 0} />
        <Stat label="Total plays" value={data.total_plays || 0} />
        <Stat label="Total sales" value={data.total_sales || 0} />
        <Stat label="Revenue" value={dollars(data.revenue_cents || 0)} />
        <Stat label="Tips earned" value={dollars(data.tips_cents || 0)} accent />
      </div>

      <div className="border border-[#2A2A2A] bg-[#121212] p-4 md:p-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gray-500 mb-4">Plays vs sales · top 15 tracks</div>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data.per_track || []} margin={CHART_MARGIN}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" />
              <XAxis dataKey="title" tick={AXIS_TICK} angle={-20} textAnchor="end" interval={0} />
              <YAxis tick={AXIS_TICK} />
              <Tooltip contentStyle={TOOLTIP_STYLE} />
              <Bar dataKey="plays" fill="#FF4500" />
              <Bar dataKey="sales" fill="#9CA3AF" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, accent = false }) {
  return (
    <div className={`border p-4 ${accent ? "border-[#FF4500]/50 bg-[#FF4500]/5" : "border-[#2A2A2A] bg-[#121212]"}`}>
      <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500">{label}</div>
      <div className={`font-display text-2xl md:text-3xl mt-1 ${accent ? "text-[#FF4500]" : ""}`}>{value}</div>
    </div>
  );
}
